var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 16,
    fill: "url(#paint0_linear_136_7)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_136_7",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 16,
    fill: "url(#paint1_linear_136_7)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_136_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-134.725 34.8691H14.1431C13.9064 35.0329 13.6805 35.1966 13.4547 35.3676C10.7154 37.4415 8.72652 40.0904 7.82678 43.0521H-134.725V34.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.073 34.8691V43.0521H81.6269C80.6689 39.8502 78.4542 37.0122 75.4016 34.8691H222.073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1541 58.3817H-134.725V50.1987H7.83405C8.80299 53.4042 11.0542 56.2422 14.1541 58.3817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.073 50.1987V58.3817H75.3906C75.6274 58.2179 75.8532 58.0506 76.0754 57.8796C78.7783 55.8056 80.738 53.1604 81.6195 50.1987H222.073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6198 45.0645H47.7284V47.7642H39.6198V45.0645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0334 47.7644H50.4312V49.1142C50.4312 49.8601 49.8265 50.4641 49.0798 50.4641H38.2684C37.5217 50.4641 36.917 49.8601 36.917 49.1142V47.7644H29.3148C27.5663 47.7644 26.0218 46.651 25.4681 44.9955L20.6088 30.4307V59.9096C20.6088 62.1436 22.4265 63.9592 24.6631 63.9592H62.6851C64.9217 63.9592 66.7394 62.1436 66.7394 59.9096V30.4307L61.8801 44.9918C61.3264 46.6473 59.7819 47.7607 58.0334 47.7607V47.7644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0798 23.4663H38.2684C36.0318 23.4663 34.2141 25.2819 34.2141 27.5159V28.8658H22.9365L28.0325 44.1401C28.2183 44.6932 28.7319 45.0643 29.3147 45.0643H36.917V43.7144C36.917 42.9685 37.5216 42.3645 38.2684 42.3645H49.0798C49.8265 42.3645 50.4312 42.9685 50.4312 43.7144V45.0643H58.0334C58.6162 45.0643 59.1298 44.6932 59.3156 44.1401L64.4117 28.8658H53.1304V27.5159C53.1304 25.2819 51.3127 23.4663 49.0761 23.4663H49.0798ZM36.917 28.8658V27.5159C36.917 26.77 37.5216 26.1661 38.2684 26.1661H49.0798C49.8265 26.1661 50.4312 26.77 50.4312 27.5159V28.8658H36.917Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_7",
    x1: 0,
    y1: 44,
    x2: 88,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_136_7",
    x1: 0,
    y1: 44,
    x2: 88,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortlogo);
export default __webpack_public_path__ + "static/media/shortlogo.5faeb3cb4774b5dea4f6a24206e324c6.svg";
export { ForwardRef as ReactComponent };